<template>
    <div v-if="hasCount">
        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <b-pagination v-model="filter.page" :total-rows="rows" :per-page="filter.pageSize"
            aria-controls="table-list-users" class="m-2" size="sm">
        </b-pagination>
    </div>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'

export default {
    name: 'CoursePagination',

    data() {
        return {
            filter: {
                page: 1,
                pageSize: InitPageSize.CoursePageSize
            },

            rows: 0
        }
    },

    computed: {
        hasCount() {
            return this.rows > 0;
        }
    },

    components: {
        AlertDismiss
    },

    async mounted() {
        await this.getCount();

        await this.paginationFilter();

        this.$eventBus.$on(EventNames.CreatedCourse, async () => {
            await this.getCount();
            this.paginationFilter();
        });
    },

    methods: {
        ...mapActions(["countCourses"]),

        paginationFilter() {
            this.$eventBus.$emit(EventNames.PaginationFilterCourse, {page: this.filter.page -1, pageSize: this.filter.pageSize});
        },

        async getCount() {
            let result = await this.countCourses();
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.rows = result.data;
        }
    },

    watch: {
        //cada ves que se haga un click al paginador entonces emite el evento
        async "filter.page"() {
            this.paginationFilter();
        },
    },

    
}
</script>
